export default __webpack_public_path__ + "static/media/Ann_tmb.40c8f3ca.jpg";